import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useWebSocket } from '../../Context/WsContext';
import notification from '../Audios/notification.mp3';
import { useNavigate } from 'react-router-dom';
import REQUEST from '../../modules/request';
import 'moment/locale/pt-br';
import moment from 'moment';

const icons = {
    Message_Notificacao: 'bi-chat-left-dots',
    Quest_Notificacao: 'bi-question-square',
    System_Notificacao: 'bi-gear',
};

const Notificacao = ({ notification, visualizar, last }) => {

    const [timeDiff, setTimeDiff] = useState('há alguns segundos');
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeDiff(moment(notification.criado_em).locale('pt').fromNow());
        }, 30000);
        setTimeDiff(moment(notification.criado_em).locale('pt').fromNow());

        return () => clearInterval(interval);
    }, []);

    const handleClickNotification = useCallback((url) => {
        document.activeElement.blur();
        navigate(url);
        visualizar();
    }, [visualizar]);

    return (
        <li className={`py-1 d-flex align-items-center ${last ? '' : 'border-bottom'}`} role={notification.url ? 'button' : undefined} onClick={() => handleClickNotification(notification.url)}>
            <i className={`bi ${icons[notification.tipo]} fs-3 mx-3`}/>
            <div className='d-flex flex-column'>
                <span>{notification.mensagem}</span>
                <span className='fs-7 text-secondary'>{timeDiff}</span>
            </div>
        </li>
    );
};

const Notificacoes = () => {

    const { addEvent, removeEvent, isConnected } = useWebSocket();
    const [notifications, setNotifications] = useState([]);
    const [allowAudio, setAllowAudio] = useState(true);
    const listRef = useRef();
    const audio = useRef();

    useEffect(() => {
        REQUEST.post('/notificacoes/listar')
            .then(res => res.data)
            .then(setNotifications)
            .catch(console.log);
    }, []);

    useEffect(() => {
        const handleNewNotification = (resp) => {
            setNotifications(prevNotifications => [resp, ...prevNotifications]);
            allowAudio && audio.current.play();
        };
        addEvent('notificacao', handleNewNotification);

        return () => removeEvent('notificacao', handleNewNotification);
    }, [addEvent, removeEvent, isConnected, allowAudio]);
    
    const visualizarTodas = useCallback(() => {
        REQUEST.post('/notificacoes/visualizar', { all: true })
            .then(() => setNotifications([]))
            .catch(console.log);
    }, []);

    const visualizar = useCallback((id) => {
        REQUEST.post('/notificacoes/visualizar', { id })
            .then(() => setNotifications(prevNotifications => prevNotifications.filter(not => not.id !== id)))
            .catch(console.log);
    }, []);

    const onOpenNotificacoes = useCallback(() => {
        listRef.current.scrollTop = 0;
    }, []);

    const RenderedNotifications = useMemo(() => {
        if(notifications.length) return notifications.map((notification, index) => (
            <Notificacao key={notification.id} notification={notification} visualizar={() => visualizar(notification.id)} last={index === (notifications.length - 1)} />
        ));
        else return (
            <div className='my-4 text-secondary text-center'>Nenhuma notificação</div>
        );
    }, [notifications]);
    
    return (
        <div className='notifications position-relative me-2'>
            <button className='btn btn-light position-relative notifications-button' count={notifications.length > 9 ? '+9' : notifications.length} onClick={onOpenNotificacoes}>
                <i className='bi bi-bell-fill' />
            </button>
            <ul className='position-absolute top-100 end-0 rounded notifications-modal mt-1 border bg-white p-0' onMouseDown={e => e.preventDefault()}>
                <audio src={notification} className='d-none' ref={audio} />
                <div className='px-3 py-2 d-flex align-items-center justify-content-between border-bottom'>
                    <span className='fs-5'>Notificações { notifications.length ? `(${notifications.length})` : '' }</span>
                    <span className='d-flex gap-2'>
                        {/* <button className='btn btn-light py-1 px-2 mx-2' title='Histórico de notificações' onClick={e => e.preventDefault()}>
                            <i className='bi bi-clock' />
                        </button> */}
                        <button className='btn btn-light py-0 px-1 fs-5' title={allowAudio ? 'Desativar som' : 'Ativar som'} onClick={() => setAllowAudio(!allowAudio)}>
                            <i className={`bi bi-volume-${allowAudio ? 'up' : 'mute'}-fill`} />
                        </button>
                        <button className='btn btn-light py-0 px-1 fs-5' title='Marcar todas como visualizada' onClick={visualizarTodas}>
                            <i className='bi bi-check-all' />
                        </button>
                    </span>
                </div>
                <div className='notifications-list' ref={listRef}>
                    { RenderedNotifications }
                </div>
            </ul>
        </div>
    );
};

export default memo(Notificacoes);